import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import { LocationStable } from '../models/locations';
import { HealthSystemDALEnumsLocationStableType } from '../api/HealthSystemApi';

interface LocationStableSelectProps {
  value: number;
  onLocationStableChange: (value: HealthSystemDALEnumsLocationStableType) => void;
  cssClass?: string;
  fullWidth?: boolean;
  allowAny?: boolean;
  selectId?: string;
  includeOnly?: LocationStable[];
  disabled?: boolean;
}

export const LocationStableMap: { [key in LocationStable]: { trans: string } } = {
  [LocationStable.Fatting]: { trans: 'f-loc-stable-fat' },
  [LocationStable.Nursery]: { trans: 'f-loc-stable-nur' },
  [LocationStable.Farrowing]: { trans: 'f-loc-stable-far' },
  [LocationStable.Gestation]: { trans: 'f-loc-stable-ges' },
  [LocationStable.Mating]: { trans: 'f-loc-stable-mat' },
  [LocationStable.Quarantaine]: { trans: 'f-loc-stable-qua' },
  [LocationStable.Calm]: { trans: 'f-loc-stable-clm' },
  [LocationStable.Gilts]: { trans: 'f-loc-stable-gil' },
  [LocationStable.Breeding]: { trans: 'f-loc-stable-bre' },
  [LocationStable.Unknown]: { trans: 'f-loc-stable-unknown' }
};

const LocationStableSelect = ({
  value,
  onLocationStableChange,
  cssClass,
  fullWidth,
  allowAny,
  selectId,
  includeOnly,
  disabled
}: LocationStableSelectProps) => {
  const { t } = useTranslation();

  const handleLocationStableChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const stableValue = event.target.value as HealthSystemDALEnumsLocationStableType;

    //callback
    onLocationStableChange(stableValue);
  };

  return (
    <FormControl className={cssClass} fullWidth={fullWidth} size="small" variant="outlined" disabled={disabled}>
      <InputLabel id="locationStableLabel">{t('f-loc-stable')}</InputLabel>
      <Select
        label={t('f-loc-stable')}
        labelId="locationStableLabel"
        id={selectId || 'locationStableSelect'}
        value={value}
        onChange={handleLocationStableChange}
      >
        {allowAny && <MenuItem value={0}>{t('f-any')}</MenuItem>}
        {Object.entries(LocationStableMap)
          .filter(([key]) => Number(key) !== LocationStable.Unknown) // Filter out 'Unknown'
          .filter(([key]) => !includeOnly || includeOnly.includes(Number(key))) // Filter out if includeOnly is set
          .map(([key, value]) => (
            <MenuItem key={key} value={Number(key)}>
              {t(value.trans)}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default LocationStableSelect;
